/* eslint no-console:0 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import pagesHelper from 'src/global/pages_helper';
import { renderComponent, renderComponents } from 'src/global/react_helper';
import { purposeAttributes } from 'src/global/test_helper';
// Initializers
import '../initializers/amplitude';
import '../initializers/authentification';
import '../initializers/i18n';
import '../initializers/krpano';
import '../initializers/react';
import '../initializers/sentry';
import '../initializers/toasts';
import '../initializers/turbo';

window.pagesHelper = pagesHelper;
window.renderComponent = renderComponent;
window.renderComponents = renderComponents;
window.purposeAttributes = purposeAttributes;
